import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_7 = { style: {"display":"flex","justify-content":"center","margin-top":"10px"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")

import stubs from '@/init';
import { reactive } from 'vue';
import _ from 'lodash';

import Wapper from '@/components/common/high/wapper.vue';
import WeightSettingController from './controller/WeightSetting.Controller';
import { WeightSettingVO } from './vo';
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const controller: WeightSettingController = stubs.injector.get(
  WeightSettingController
);
const state = reactive({
  backup: [] as Array<WeightSettingVO>,
  data: [] as Array<WeightSettingVO>,
  editMode: false,
});

const tableColumns: any[] = [
  { label: '风险模块', prop: 'sysRiskModuleName' },
  { label: '模块权重', prop: 'sysRiskModuleWeight' },
  { label: 'KRI', prop: 'sysRiskModuleKriName' },
  { label: 'KRI权重', prop: 'sysRiskModuleKriWeight' },
];

const calcColSpanMethod = (
  data: Array<any>,
  key: string,
  fromIndex: number,
  toIndex: number
) => {
  if (fromIndex <= toIndex) {
    throw new Error('fromIndex不能小于等于toIndex');
  }
  const indicies = [fromIndex, toIndex];
  const sliceData = data.slice(toIndex, fromIndex);
  sliceData.forEach((it) => (it[key + '-span'] = 1));
  if (fromIndex === toIndex + 1) {
    return [fromIndex, toIndex];
  }
  sliceData.reverse();
  sliceData
    .filter((it) => it)
    .reduce((prev, cur, index) => {
      if (prev[key] === cur[key]) {
        cur[key + '-span'] += prev[key + '-span'];
        prev[key + '-span'] = 0;
      } else {
        indicies.push(fromIndex - index);
      }
      return cur;
    });
  return indicies;
};

const edit = () => {
  state.editMode = true;
};

const confirm = async () => {
  for (const key of ['sysRiskModuleWeight', 'sysRiskModuleKriWeight']) {
    let value = 0;
    state.data.forEach((it: any) => {
      if (it[key + '-span'] > 0) {
        value = it[key];
      } else {
        it[key] = value;
      }
    });
  }
  const reqBody = _.cloneDeep(state.data);
  reqBody.forEach((it: any) => {
    for (const key of Object.keys(it)) {
      if (['sysRiskModuleWeight', 'sysRiskModuleKriWeight'].includes(key)) {
        it[key] = it[key] / 100;
      }
    }
  });
  await controller.set(reqBody);
  ElMessage.success({
    message: '设置成功',
  });
  state.editMode = false;
  state.backup = _.cloneDeep(state.data);
};

const cancel = () => {
  state.data = _.cloneDeep(state.backup);
  state.editMode = false;
};

const handleSpanMethod = ({ row, column, rowIndex, columnIndex }: any) => {
  const prop = tableColumns[columnIndex].prop;
  return [row[prop + '-span'], 1];
};

const init = async () => {
  state.data = await controller.load();
  state.data.forEach((it: any) => {
    for (const key of Object.keys(it)) {
      if (['sysRiskModuleWeight', 'sysRiskModuleKriWeight'].includes(key)) {
        it[key] = it[key] * 100;
      }
    }
  });
  let iter = [state.data.length, 0];
  for (const prop of tableColumns.map((it) => it.prop)) {
    let newIter: number[] = [];
    iter.reduce((fromIndex, toIndex) => {
      newIter = [
        ...newIter,
        ...calcColSpanMethod(state.data, prop, fromIndex, toIndex),
      ];
      return toIndex;
    });
    newIter.sort((a, b) => b - a);
    iter = Array.from(new Set(newIter));
  }
  state.backup = _.cloneDeep(state.data);
};

init();

return (_ctx: any,_cache: any) => {
  const _component_simple_table_column = _resolveComponent("simple-table-column")!
  const _component_simple_input = _resolveComponent("simple-input")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Wapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_table, {
            class: "common-table",
            data: _unref(state).data,
            "span-method": handleSpanMethod,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_simple_table_column, {
                label: "风险模块",
                prop: "sysRiskModuleName"
              }),
              _createVNode(_component_simple_table_column, { label: "模块权重" }, {
                default: _withCtx(({ row }) => [
                  (!_unref(state).editMode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.sysRiskModuleWeight) + "%", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _createVNode(_component_simple_input, {
                          modelValue: row.sysRiskModuleWeight,
                          "onUpdate:modelValue": ($event: any) => ((row.sysRiskModuleWeight) = $event),
                          type: "number"
                        }, {
                          append: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_simple_table_column, {
                label: "KRI",
                prop: "sysRiskModuleKriName"
              }),
              _createVNode(_component_simple_table_column, { label: "KRI权重" }, {
                default: _withCtx(({ row }) => [
                  (!_unref(state).editMode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row.sysRiskModuleKriWeight) + "%", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        _createVNode(_component_simple_input, {
                          modelValue: row.sysRiskModuleKriWeight,
                          "onUpdate:modelValue": ($event: any) => ((row.sysRiskModuleKriWeight) = $event),
                          type: "number",
                          disabled: row.sysRiskModuleKriName === '逆向事件'
                        }, {
                          append: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (!_unref(state).editMode)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: edit
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: confirm
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: cancel }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ], 64))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})